import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { OrderClientStatus } from '../../../../../core';

@JsonConverter
export class OrderClientStatusAdapter implements JsonCustomConvert<OrderClientStatus | undefined> {
    serialize(status: OrderClientStatus): any | undefined {
        return status ? String(status) : undefined;
    }

    deserialize(status: any): OrderClientStatus | undefined {
        switch (status) {
            case 'ACCEPTED':
                return OrderClientStatus.ACCEPTED;
            case 'PENDING':
                return OrderClientStatus.PENDING;
            case 'REJECTED':
                return OrderClientStatus.REJECTED;
            case 'SENT':
                return OrderClientStatus.SENT;
            case 'EXPIRED':
                return OrderClientStatus.EXPIRED;
            case 'NON SUCCESSFUL SIGNATURE':
                return OrderClientStatus.NON_SUCCESSFUL_SIGNATURE;
            default:
                return undefined;
        }
    }
}
